(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["images-carousel"] && !Shopify.designMode) return;
  try {
    


document.addEventListener("DOMContentLoaded", () => {
  
  const slides = document.querySelectorAll(".carousel__slide.images__slide");
  if (!slides.length) return;

  slides.forEach(slide => {
    const url = slide.getAttribute("data-video-url");
    if (!url || url.trim() === "") return; // skip slides without video

    // Ensure slide can anchor an absolute overlay
    const cs = getComputedStyle(slide);
    if (cs.position === "static") slide.style.position = "relative";

    // Build an overlay per slide (once)
    if (slide._lbBuilt) return;
    slide._lbBuilt = true;

    const lb = document.createElement("div");
    lb.className = "slideVideoOverlay";
    lb.style.cssText = `
      position:absolute; inset:0; display:none; place-items:center;
      background:#fff); z-index:5;
    `;

    const shell = document.createElement("div");
    shell.className = "slideVideoShell";
    shell.style.cssText = `
      position:relative; width:100%; height:100%;
      background:#fff; border-radius:12px; overflow:hidden;
    
    `;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "slideVideoClose";
    btn.setAttribute("aria-label", "Close");
    btn.style.cssText = `
      display: none; position:absolute; top:8px; right:10px; z-index:2;
      width:40px; height:40px; border:0; border-radius:999px;
      background:rgba(0,0,0,.55); color:#fff; font-size:24px; line-height:1; cursor:pointer;
    `;
    btn.textContent = "×";

    const video = document.createElement("video");
    video.className = "slideVideo";
    video.controls = false;
    video.autoplay = true;
    video.playsInline = true;
    video.loop = true;
    video.muted = true;
    video.volume = 0.00;
    video.preload = "metadata";
    video.style.cssText = `
      width:100%; height:100%; display:block;
      object-fit:cover; background:#000;
    `;

    // Optional poster from data attribute
    const poster = slide.getAttribute("data-video-poster");
    if (poster) video.poster = poster;

    shell.appendChild(btn);
    shell.appendChild(video);
    lb.appendChild(shell);
    slide.appendChild(lb);

    // Open on click / keyboard
    const open = () => {
      video.src = url;
      lb.style.display = "grid";
      // Try autoplay (may require user interaction on some devices)
      const p = video.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
      btn.focus();
    };
    slide.addEventListener("click", open);
    slide.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); }
    });
    slide.tabIndex = slide.tabIndex || 0;

  slides.forEach(slide =>  {
    open(slide);
  });

    // Close handlers
    const close = () => {
      lb.style.display = "none";
      video.pause();
      video.removeAttribute("src");
      video.load();
      slide.focus(); // return focus to opener
    };
    btn.addEventListener("click", close);
    lb.addEventListener("click", (e) => { if (e.target === lb) close(); });
    slide.addEventListener("keydown", (e) => { if (e.key === "Escape" && lb.style.display !== "none") close(); });

    // Prevent clicks inside shell from closing
    shell.addEventListener("click", (e) => e.stopPropagation());
  });
});


  } catch(e) { console.error(e); }
})();
})();
